import * as CR from '../services/countryRegions';
import { helpers } from '../utils';

export const ACTION_COUNTRY_REGIONS_LOAD_LIST = 'countryRegions/loadList';
export const ACTION_COUNTRY_REGIONS_LOAD_ITEM = 'countryRegions/loadItem';
export const ACTION_COUNTRY_REGIONS_CREATE = 'countryRegions/create';
export const ACTION_COUNTRY_REGIONS_UPDATE = 'countryRegions/update';
export const ACTION_COUNTRY_REGIONS_REMOVE = 'countryRegions/remove';

export default {
  namespace: 'countryRegions',

  state: null,

  effects: {
    * loadList({ payload }, { call, select }) {
      try {
        const { selectedClient } = yield select(store => store.app);
        return yield call(CR.countryRegionsListRequest, { ...payload, clientId: selectedClient.id });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadItem({ payload }, { call, select }) {
      try {
        const { selectedClient } = yield select(store => store.app);
        return yield call(CR.countryRegionsItemRequest, { ...payload, clientId: selectedClient.id });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * create({ payload }, { call, select }) {
      try {
        const { selectedClient } = yield select(store => store.app);
        const { data } = payload;
        return yield call(CR.countryRegionsCreateRequest, { clientId: selectedClient.id }, data);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * update(
      {
        payload: { id, data },
      },
      { call, select },
    ) {
      try {
        const { selectedClient } = yield select(store => store.app);
        yield call(CR.countryRegionsUpdateRequest, { id, clientId: selectedClient.id }, { ...data });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * remove(
      {
        payload: { id },
      },
      { call, select },
    ) {
      try {
        const { selectedClient } = yield select(store => store.app);
        return yield call(CR.countryRegionsRemoveRequest, {
          id,
          clientId: selectedClient.id,
        });
      } catch (e) {
        return e;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/countryRegions.js